import React from 'react';
import ReactDOM from 'react-dom';
import ElpPage from "./educationalLand";

const el = document.querySelector('#elp-side-panel .elp-panel');

if (el) {
    ReactDOM.render(
        <ElpPage/>
        ,
        el
    )
}
